// extracted by mini-css-extract-plugin
export default {"popup":"TransparentPopup__popup--2Cb","header":"TransparentPopup__header--2Ia","inner":"TransparentPopup__inner--1cC","overlay":"TransparentPopup__overlay--114"};